import React, { useEffect, useState, useCallback } from "react";
import { countryTr } from "../util/countryTr";
import modApi from "../util/moderationApi";
import { baseURL } from "../util/config";

/* ------------------------------------------------------------------ ban list */
export const BannedAccounts = () => {
  const [data, setData] = useState({ hosts: [], users: [] });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await modApi.banned();
    if (res?.status) setData({ hosts: res.hosts || [], users: res.users || [] });
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const unban = async (type, row) => {
    if (!window.confirm(`${row.name || "Hesap"} üzerindeki engel kaldırılsın mı?`)) return;
    const res = await modApi.ban(type, row._id, "panelden engel kaldırıldı");
    if (res?.status) load();
    else window.alert(res?.message || "İşlem tamamlanamadı.");
  };

  const rows = [
    ...data.hosts.map((h) => ({ ...h, _type: "host" })),
    ...data.users.map((u) => ({ ...u, _type: "user" })),
  ];

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>Engellenen Hesaplar</h4>
          <div className="sub">Kural ihlali sebebiyle platformdan çıkarılan host ve kullanıcılar.</div>
        </div>
        <button type="button" className="btn btn-primary" onClick={load}>Yenile</button>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Hesap</th>
                  <th>Tür</th>
                  <th>E-posta</th>
                  <th>Ülke</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="5"><div className="badu-empty">Yükleniyor…</div></td></tr>
                ) : rows.length === 0 ? (
                  <tr><td colSpan="5"><div className="badu-empty">Engellenmiş hesap yok.</div></td></tr>
                ) : (
                  rows.map((row) => (
                    <tr key={`${row._type}-${row._id}`}>
                      <td>
                        <div className="d-flex align-items-center" style={{ gap: 9 }}>
                          {row.image && (
                            <img
                              className="table_image"
                              src={row.image?.startsWith("http") ? row.image : `${baseURL}${row.image}`}
                              alt=""
                            />
                          )}
                          <b>{row.name || "—"}</b>
                        </div>
                      </td>
                      <td>
                        <span className="badu-chip wait">
                          {row._type === "host" ? "Host" : "Kullanıcı"}
                        </span>
                      </td>
                      <td>{row.email || "—"}</td>
                      <td>{countryTr(row.country)}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => unban(row._type, row)}
                        >
                          Engeli kaldır
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

/* -------------------------------------------------------------- banned words */
export const BannedWords = () => {
  const [words, setWords] = useState([]);
  const [word, setWord] = useState("");
  const [action, setAction] = useState("mask");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await modApi.bannedWords();
    if (res?.status) setWords(res.words || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const add = async (e) => {
    e.preventDefault();
    if (!word.trim()) return;
    const res = await modApi.addBannedWord(word.trim(), action);
    if (res?.status) {
      setWord("");
      load();
    } else {
      window.alert(res?.message || "Kelime eklenemedi.");
    }
  };

  const remove = async (row) => {
    if (!window.confirm(`"${row.word}" listeden silinsin mi?`)) return;
    const res = await modApi.deleteBannedWord(row._id);
    if (res?.status) load();
  };

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>Yasaklı Kelimeler</h4>
          <div className="sub">
            Sohbet filtresi. "Maskele" kelimeyi yıldızlar, "Engelle" mesajın tamamını durdurur.
          </div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 12 }}>
        <div className="card-body">
          <form onSubmit={add} className="d-flex align-items-end" style={{ gap: 10, flexWrap: "wrap" }}>
            <div style={{ flex: "1 1 240px", minWidth: 0 }}>
              <label className="form-label">Kelime</label>
              <input
                className="form-control"
                value={word}
                onChange={(e) => setWord(e.target.value)}
                placeholder="ör. küfür"
              />
            </div>
            <div style={{ width: 160 }}>
              <label className="form-label">Davranış</label>
              <select
                className="form-control"
                value={action}
                onChange={(e) => setAction(e.target.value)}
              >
                <option value="mask">Maskele</option>
                <option value="block">Mesajı engelle</option>
              </select>
            </div>
            <button type="submit" className="btn btn-primary">Ekle</button>
          </form>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Kelime</th>
                  <th>Davranış</th>
                  <th>Yakalama</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4"><div className="badu-empty">Yükleniyor…</div></td></tr>
                ) : words.length === 0 ? (
                  <tr><td colSpan="4"><div className="badu-empty">Henüz kelime eklenmedi.</div></td></tr>
                ) : (
                  words.map((row) => (
                    <tr key={row._id}>
                      <td><b>{row.word}</b></td>
                      <td>
                        <span className={`badu-chip ${row.action === "block" ? "bad" : "wait"}`}>
                          {row.action === "block" ? "Mesajı engelle" : "Maskele"}
                        </span>
                      </td>
                      <td>{row.hitCount || 0}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger badu-destructive"
                          onClick={() => remove(row)}
                        >
                          Sil
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

/* ------------------------------------------------------------------ audit log */
export const AdminLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const res = await modApi.logs(200);
    if (res?.status) setLogs(res.logs || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const label = {
    "stream.end": "Yayın kesildi",
    "host.ban": "Host engellendi",
    "host.unban": "Host engeli kaldırıldı",
    "user.ban": "Kullanıcı engellendi",
    "user.unban": "Kullanıcı engeli kaldırıldı",
    "complaint.resolve": "Şikayet çözüldü",
    "bannedWord.add": "Yasaklı kelime eklendi",
    "bannedWord.delete": "Yasaklı kelime silindi",
  };

  return (
    <>
      <div className="badu-page-head">
        <div>
          <h4>İşlem Günlüğü</h4>
          <div className="sub">
            Kim, neyi, ne zaman yaptı. App Store'a sunulacak uyum planının kanıtı.
          </div>
        </div>
        <button type="button" className="btn btn-primary" onClick={load}>Yenile</button>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Yönetici</th>
                  <th>İşlem</th>
                  <th>Hedef</th>
                  <th>Not</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="6"><div className="badu-empty">Yükleniyor…</div></td></tr>
                ) : logs.length === 0 ? (
                  <tr><td colSpan="6"><div className="badu-empty">Henüz kayıt yok.</div></td></tr>
                ) : (
                  logs.map((row) => (
                    <tr key={row._id}>
                      <td>{new Date(row.createdAt).toLocaleString("tr-TR")}</td>
                      <td>{row.adminEmail || "—"}</td>
                      <td><b>{label[row.action] || row.action}</b></td>
                      <td>{row.targetType || "—"}</td>
                      <td style={{ maxWidth: 320, whiteSpace: "normal" }}>{row.note || "—"}</td>
                      <td>{(row.ip || "").replace("::ffff:", "") || "—"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
